module.exports = __webpack_public_path__ + "images/10c4c6d5f379d85b5a4b588443c0cb37.png";